<template>
  <v-responsive
    @click="dialog = true"
    @keyup.enter="dialog = true"
    :style="styles"
    class="grid-item"
    :class="{ 'with-background': !!backgroundImage }"
    :aspect-ratio="480 / 280"
    tabindex="0"
    role="button"
  >
    <SliderModal
      :prevId="prevId"
      :nextId="nextId"
      :id="item.id"
      name="article"
      scrollToElement
      v-model="dialog"
    >
      <Memory :color="color" :memory="item" :pageSlug="pageSlug" />
    </SliderModal>
    <div class="grid-item__bg"></div>
    <div class="grid-item__description">
      “{{ item.description.substr(0, 100) + "..." }}”
    </div>
    <div class="grid-item__footer">
      <div class="grid-item__author">{{ item.full_name }}</div>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <div v-on="on" class="grid-item__page">{{ item.pages }}</div>
        </template>
        <span>{{ item.pages }}</span>
      </v-tooltip>
    </div>
  </v-responsive>
</template>

<script>
import Memory from "./Memory";

export default {
  name: "GridItem",
  components: {
    Memory,
  },
  props: {
    item: Object,
    pageSlug: String,
    prevId: Number,
    nextId: Number,
  },
  data() {
    return {
      dialog: false,
      colors: ["#262729", "#EE3624"],
    };
  },
  computed: {
    styles() {
      const styles = {
        backgroundColor: this.color,
      };

      if (this.backgroundImage) {
        styles.backgroundImage = this.backgroundImage;
      }

      return styles;
    },
    backgroundImage() {
      const preview = this.item.preview_urls?.large;
      if (preview) {
        return `url(${preview})`;
      }
      return null;
    },
    color() {
      return this.colors[this.item.id % this.colors.length];
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

.grid-item::v-deep .v-responsive__content {
  position: relative;
  z-index: 1;
}

.grid-item {
  display: flex;
  align-items: flex-end;
  padding: 20px;
  cursor: pointer;
  background-size: cover;
  background-position-x: center;
  background-position-y: 25%;
  position: relative;
  color: $jude-white;

  &.with-background:after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: linear-gradient(
      180deg,
      rgba(26, 26, 26, 0) 0%,
      rgba(26, 26, 26, 0.85) 100%
    );
  }

  &:hover {
    filter: brightness(105%);
  }

  &__description {
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 20px;
    text-shadow: 0px 3px 4px rgba(0, 0, 0, 0.5);
  }

  &__footer {
    font-weight: 800;
    font-size: 16px;
    line-height: 18px;
    display: flex;
  }

  &__page {
    color: #b1b3b3;
    margin-left: 10px;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
